// Admin routes for P6-D (IMPORT-01/02, INVENTORY-03, POS-03/04/06, jobs DLQ recorder + schedules). Owned by that worker; the router mounts
// whatever this returns under the app shell (before the store-area placeholder), so modules never
// edit router.tsx. Paths follow IA §2.1:
//   …/products/import        IMPORT-01/02 import and export (nav "Import", products.bulk)
//   …/inventory/transfers    INVENTORY-03 transfers, batches and the nightly stock check
//   …/sell/registers         POS-04/06 registers, shifts and the offline sync report (nav "Registers")
import {
  createRoute,
  type AnyRoute,
  type RouteComponent,
  lazyRouteComponent,
} from "@tanstack/react-router";

// Pages are code-split: each loads when its route opens, not with the shell.
const load1 = () => import("../imports/ImportsPage");
const ImportsPage = lazyRouteComponent(load1, "ImportsPage");
const load2 = () => import("../inventory/TransfersPage");
const TransfersPage = lazyRouteComponent(load2, "TransfersPage");
const load3 = () => import("../pos/RegistersPage");
const RegistersPage = lazyRouteComponent(load3, "RegistersPage");

export function importsRoutes(appRoute: AnyRoute): AnyRoute[] {
  const at = (path: string, component: RouteComponent) =>
    createRoute({ getParentRoute: () => appRoute, path, component });
  return [
    at("/$org/$store/products/import", ImportsPage),
    at("/$org/$store/inventory/transfers", TransfersPage),
    at("/$org/$store/sell/registers", RegistersPage),
  ];
}
